import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/authentication/auth-service';

const LOGIN_ENDPOINT_SUFFIX = '/api/users/login';

export const httpAuthInterceptor: HttpInterceptorFn = (req, next) => {
  if (isLoginRequest(req.url)) return next(req);

  const authService = inject(AuthService);
  const token = authService.getAccessToken();
  if (!token) return next(req);

  return next(
    req.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
      },
    }),
  );
};

function isLoginRequest(url: string): boolean {
  return url.endsWith(LOGIN_ENDPOINT_SUFFIX) || url.includes(`${LOGIN_ENDPOINT_SUFFIX}?`);
}
